import useExpireToken from '@/composables/useExpireToken';
import { useMessageBox } from '@/composables/useMessageBox';
import { useToast } from '@/composables/useToast';
import { env } from '@/env';
import { RoleType } from '@/models/interface/user';
import { usePopStore } from '@/stores/pop';
import { useUserStore } from '@/stores/user';
import type { AxiosError } from 'axios';
import axios from 'axios';

const { openToast } = useToast();
const { openMessageBox } = useMessageBox();
const userStore = useUserStore();
const { forceLogoutMsg } = userStore; //因為router不是使用正常router跳轉方式，pinia會重載token直接解構會異常
let loadingCount = 0;

const handleLoading = () => {
  loadingCount++;

  if (loadingCount > 0) {
    usePopStore().loadingStatus = true;
  }
};
const handleCloseLoading = () => {
  loadingCount--;

  if (loadingCount === 0) {
    usePopStore().loadingStatus = false;
  }
};

const handleExpireToken = () => {
  if (!useExpireToken(userStore.token)) {
    console.log('handleExpireToken');
    const loginPage =
      userStore.userData.roleType === RoleType['isJunior'] ? '/loginJunior' : '/login';
    userStore.initUserData();
    window.location.href = loginPage; //現在router無法直接用router.push跳轉
    return;
  }
};

const axiosInstance = axios.create({
  baseURL: env.apiBaseUrl,
  timeout: 10000 // 請求超時時間
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.headers?.disableGlobalLoading) handleLoading();

    if (!config.headers?.unAuthorization) {
      config.headers['Authorization'] = `Bearer ${userStore.token}`;
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    handleCloseLoading();
    if (response.status !== 200) {
      //log api 會201
      if (response.status !== 201) {
        openToast('error', response.data.errorMessage);
      }
    }
    return response;
  },
  (error: AxiosError) => {
    const { config, message, response } = error;
    handleCloseLoading();
    console.log(config);
    // Token 過期
    if (config && response?.status === 401 && userStore.token) {
      console.log('過期判斷成立');

      openMessageBox(message, 'OK', handleExpireToken);
    } else {
      if (config?.headers?.['X-Silent-Error'] === 'true') {
        return Promise.reject(error);
      }
      openToast('error', message);
    }
    console.log(error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
